import { render } from "./BackgroundDecor.vue?vue&type=template&id=9153af28&scoped=true"
import script from "./BackgroundDecor.vue?vue&type=script&lang=js"
export * from "./BackgroundDecor.vue?vue&type=script&lang=js"

import "./BackgroundDecor.vue?vue&type=style&index=0&id=9153af28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9153af28"]])

export default __exports__